"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Angular
require("@angular/platform-browser");
require("@angular/platform-browser-dynamic");
require("@angular/core");
require("@angular/common");
require("@angular/http");
require("@angular/router");
// RxJS
require("rxjs");
// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...
require("./libs");



//////////////////
// WEBPACK FOOTER
// ./src/vendor.ts
// module id = 1336
// module chunks = 1